import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconCheckmark = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" size={size} {...props}>
        <StyledPath
            d="M31 0.998657L10.8773 29.744C10.6118 30.1255 10.2595 30.4384 9.8493 30.6571C9.43912 30.8757 8.98287 30.9937 8.51814 31.0014C8.0534 31.009 7.5935 30.9062 7.17632 30.7012C6.75914 30.4963 6.39663 30.1952 6.11867 29.8227L1 22.9987"
            color="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledSvg>
);
